.floatingMenu {
  z-index: var(--mantine-z-index-popover);
  gap: var(--mantine-spacing-xs);
  background-color: var(--mantine-color-default);
  border: 1px solid
    light-dark(var(--mantine-color-gray-4), var(--mantine-color-gray-7));
  border-radius: var(--mantine-radius-default);
  padding: var(--mantine-spacing-2xs);
  overflow-y: auto;
}
